import { DetailsComponent } from './../details/details.component';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';

import { environment } from '../../environments/environment';
import { APIURLS, SHAREDCONSTANTS, KYCUPDATEVIEWMESSAGES } from '../_constants/constants';
import { Address, PersonDetails, PersonDetailsUpdate, Userdetails, KycDetails, KycUpdateData } from './../_models/data.structures';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';

import { TranslateService } from '../_services/translate.service';
import { TranslatePipe } from '../shared/translate/translate.pipe';
import { LoaderService } from '../_services/loader.service';
import { TimezoneService } from '../_services/timezone.service';
import { AgentProfileService } from './agent.profile.service';

@Injectable()
export class CustomerService {
    private etagValue: string;
    private kycData: KycDetails;
    private enabledMobileConnectMarket: boolean;
    private enabledHistoryMarket: boolean;
    private enabledLogoutCustomerService: boolean;
    private enabledMcLastSuccessfullLogin: boolean;
    private nvEmailUpdateBtnFlag: boolean;
    private person: PersonDetails = {
        address: new Address()
    };
    private translateKey: string;
    private translateValue: string;
    private updateStatus: boolean;
    private agentProfileService: AgentProfileService;
    private agentEmail: string;
    constructor(private router: Router, 
        private http: Http, 
        private translate: TranslateService,
        private loaderService: LoaderService, 
        private timezoneService: TimezoneService,
        agentProfileService: AgentProfileService
    ) {
        this.agentProfileService = agentProfileService;
        this.agentEmail = this.agentProfileService.loadAgentProfile().email;
    }


    getUserByRequest(subValue: string, opcoValue: string, ds: DialogService, selectedCountry?: string) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const reqOptions = new RequestOptions();
        let URL;
        if (opcoValue === 'ro') {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_Ro).replace('{sub}', subValue);
        }else if(opcoValue === 'vo'){
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_Vo).replace('{sub}', subValue);
        }
        else if(opcoValue === 'al') {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_AL).replace('{sub}', subValue);
        }
        else if(opcoValue === 'cz') {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_CZ).replace('{sub}', subValue);
        }
        else if(opcoValue === 'it') {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_IT).replace('{sub}', subValue);
        }
         else {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details).replace('{sub}', subValue);
        }

        const params = new URLSearchParams();

        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/json');
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        if (selectedCountry !== undefined) {
            //headers.append('x-vf-trace-nv_opco_id', opcoValue+"-"+selectedCountry);             
            params.append("qcountry", selectedCountry);
        }

        const options = new RequestOptions({ search: params, headers: headers, withCredentials: true });

        this.http.get(URL, options).subscribe(
            data => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                if (opcoValue === 'ro' ||  opcoValue === 'vo' ||  opcoValue === 'al' || opcoValue === 'cz' || opcoValue === 'it') {
                    this.person = data.json();
                    this.getUpdatedRoData(this.person);
                    this.setEtag(data.json().etag);
                } else {
                    this.person = data.json().user_details;

                    if (this.person.gender && this.person.gender !== null && this.person.gender !== 'undefined') {
                        this.person.gender = this.person.gender.charAt(0).toUpperCase() + this.person.gender.slice(1);
                    }

                    this.kycData = data.json().kyc_details;
                    if (this.kycData.history !== undefined && this.kycData.history !== null) {
                        this.kycData.history = this.kycData.history.slice().reverse();
                    }

                    //this.setEtag(data.headers.get('ETag'));
                    this.setEtag(data.json().ETag);

                    this.enabledMobileConnectMarket = data.json().enabledMobileConnectMarket || false;
                    this.enabledHistoryMarket = data.json().enabledHistoryMarket || false;
                    this.enabledLogoutCustomerService = data.json().enabledLogoutCustomerService || false;
                    this.enabledMcLastSuccessfullLogin = data.json().enabledMcLastSuccessfullLogin || false;
                    this.nvEmailUpdateBtnFlag = data.json().nvEmailUpdateBtnFlag || false;
                }
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                if (err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode, 'API_ERROR')
                    });
                }
                else if (err.status === 404) {
                    ds.addDialog(NotificationDialogComponent,
                        {
                            success: false,
                            message: new TranslatePipe(this.translate).transform('USER_PROFILE_NOT_FOUND', 'KYCUPDATEVIEWMESSAGES')
                        });
                }
                else {
                    ds.addDialog(NotificationDialogComponent,
                        {
                            success: false,
                            message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                        });
                }

                if (selectedCountry === "" || typeof selectedCountry === "undefined") {
                    this.router.navigate(['/' + opcoValue + '/search']);
                }
                else {
                    this.router.navigate(['/' + opcoValue + '/search/' + selectedCountry]);
                }
            }
        );
    }

    reloadGetUserByRequest(subValue: string, opcoValue: string, ds: DialogService, selectedCountry?: string) {
        DetailsComponent.incrementRunningRequests();
        const reqOptions = new RequestOptions();
        let URL;
        if (opcoValue === 'ro') {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_Ro).replace('{sub}', subValue);
        }
        else if(opcoValue === 'vo'){
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_Vo).replace('{sub}', subValue);
        }
        else if(opcoValue === 'al'){
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_AL).replace('{sub}', subValue);
        }
        else if(opcoValue === 'cz'){
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_CZ).replace('{sub}', subValue);
        }
        else if(opcoValue === 'it'){
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details_IT).replace('{sub}', subValue);
        }
        else {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Details).replace('{sub}', subValue);
        }

        const params = new URLSearchParams();

        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/json');
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        if (selectedCountry !== undefined) {
            //headers.append('x-vf-trace-nv_opco_id', opcoValue+"-"+selectedCountry);             
            params.append("qcountry", selectedCountry);
        }

        const options = new RequestOptions({ search: params, headers: headers, withCredentials: true });

        this.http.get(URL, options).subscribe(
            data => {
                DetailsComponent.decrementRunningRequests();
                if (opcoValue === 'ro'|| opcoValue === 'vo' || opcoValue === 'al' || opcoValue === 'cz'  || opcoValue === 'it') {
                    this.person = data.json();
                    this.getUpdatedRoData(this.person);
                    this.setEtag(data.json().etag);
                } else {
                    this.person = data.json().user_details;

                    if (this.person.gender && this.person.gender !== null && this.person.gender !== 'undefined') {
                        this.person.gender = this.person.gender.charAt(0).toUpperCase() + this.person.gender.slice(1);
                    }

                    this.kycData = data.json().kyc_details;
                    if (this.kycData.history !== undefined && this.kycData.history !== null) {
                        this.kycData.history = this.kycData.history.slice().reverse();
                    }

                    //this.setEtag(data.headers.get('ETag'));
                    this.setEtag(data.json().ETag);

                    this.enabledMobileConnectMarket = data.json().enabledMobileConnectMarket || false;
                    this.enabledHistoryMarket = data.json().enabledHistoryMarket || false;
                    this.enabledLogoutCustomerService = data.json().enabledLogoutCustomerService || false;
                    this.enabledMcLastSuccessfullLogin = data.json().enabledMcLastSuccessfullLogin || false;
                    this.nvEmailUpdateBtnFlag = data.json().nvEmailUpdateBtnFlag || false;
                }

                setTimeout(() => {
                    if (this.updateStatus == true) {
                        this.loaderService.display(false);
                        this.showMessage(ds);
                        this.updateStatus = false;
                    }

                }, 1000);
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode, 'API_ERROR')
                    });
                }
                else if (err.status === 404) {
                    ds.addDialog(NotificationDialogComponent,
                        {
                            success: false,
                            message: new TranslatePipe(this.translate).transform('USER_PROFILE_NOT_FOUND', 'KYCUPDATEVIEWMESSAGES')
                        });
                }
                else {
                    ds.addDialog(NotificationDialogComponent,
                        {
                            success: false,
                            message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                        });
                }

                if (selectedCountry === "" || typeof selectedCountry === "undefined") {
                    this.router.navigate(['/' + opcoValue + '/search']);
                }
                else {
                    this.router.navigate(['/' + opcoValue + '/search/' + selectedCountry]);
                }

                setTimeout(() => {
                    //  this.loaderService.display(false);
                }, 3000);

            }
        );
    }

    verifyMail(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Email_Verify).replace('{sub}', subValue);
        const payload = '{\"email\": \"' + this.person.email + '\" }';
        this.postRequest(URL, payload, subValue, opcoValue, ds);
    }

    resetPasswordRequest(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Operations_Password_Reset).replace('{sub}', subValue);
        const payload = '{\"email\": \"' + this.person.email + '\" }';
        this.postRequest(URL, payload, subValue, opcoValue, ds);
    }
    
    activateAccountRequest(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/json');
        headers.append('external-user', this.agentEmail);
        this.loaderService.display(true);
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        const URL = (environment.BASE_URL_BACKEND + APIURLS.RO_CUSTOMER_Search_Operations_Send_Activation_Email).replace('{sub}', subValue);
        const payload = '{\"sub\": \"' + subValue + '\" }';
        this.http.post(URL, payload, options).subscribe(
            response => {
                this.translateKey = 'ACTIVATEACCOUNTLABELS';
                this.translateValue = 'RO_ACTIVATE_ACCOUNT_SUCCESS';
                this.updateStatus = true;
            },
            error => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (error.json().internalCode && this.translate.checkAPIErrorExistsByCode(error.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        title: '',
                        success: false,
                        message: new TranslatePipe(this.translate).transform('RO_ACTIVATE_ACCOUNT_FAILURE', 'ACTIVATEACCOUNTLABELS')
                    });
                }
                else if (error.status === 400) {
                    ds.addDialog(NotificationDialogComponent, {
                        title: '',
                        success: false,
                        message: new TranslatePipe(this.translate).transform('RO_ACTIVATE_ACCOUNT_WEBUSER_NOT_FOUND','ACTIVATEACCOUNTLABELS')
                    });
                } 
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        title: '',
                        success: false,
                        message: new TranslatePipe(this.translate).transform('RO_ACTIVATE_ACCOUNT_FAILURE','ACTIVATEACCOUNTLABELS')
                    });
                }
            },
            () => {
                setTimeout(() => {
                    this.refreshData(subValue, opcoValue, ds);
                    DetailsComponent.decrementRunningRequests();
                }, 1000);
            }
        );

    }
    
    roResetPasswordRequest(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.RO_CUSTOMER_Search_Operations_Password_Reset)
        const payload = '{\"sub\": \"' + subValue + '\" }';
        this.postRequestRO(URL, payload, subValue, opcoValue, ds);
    }
    
    voResetPinPasswordRequest(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.VO_CUSTOMER_Search_Operations_Pin_Reset)
        const payload = '{\"sub\": \"' + subValue + '\" }';
        this.postRequestVO(URL, payload, subValue, opcoValue, ds, 'VO_RESET_PIN_SUCCESS');
    }

    voResetPasswordRequest(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.VO_CUSTOMER_Search_Operations_Password_Reset)
        const payload = '{\"sub\": \"' + subValue + '\" }';
        this.postRequestVO(URL, payload, subValue, opcoValue, ds, 'RO_RESET_SUCCESS');
    }

    alResetPasswordRequest(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.AL_CUSTOMER_Search_Operations_Password_Reset)
        const payload = '{\"sub\": \"' + subValue + '\" }';
        this.postRequestAL(URL, payload, subValue, opcoValue, ds);
    }

    czResetPasswordRequest(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.CZ_CUSTOMER_Search_Operations_Password_Reset)
        const payload = '{\"sub\": \"' + subValue + '\" }';
        this.postRequestCZ(URL, payload, subValue, opcoValue, ds);
    }

    itResetPasswordRequest(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.IT_CUSTOMER_Search_Operations_Password_Reset)
        const payload = '{\"sub\": \"' + subValue + '\" }';
        this.postRequestCZ(URL, payload, subValue, opcoValue, ds);
    }

    postRequestCZ(URL: string, payload: string, subValue: string, opcoValue: string, ds: DialogService) {
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/json');

        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.post(URL, payload, options).subscribe(
            response => {
                this.translateKey = 'SHAREDCONSTANTS';
                this.translateValue = 'RO_RESET_SUCCESS';
                this.updateStatus = true;
            },
            error => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                if (error.json().internalCode && this.translate.checkAPIErrorExistsByCode(error.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(error.json().internalCode, 'API_ERROR')
                    });
                }
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                    });
                }
            },
            () => {
                setTimeout(() => {
                    this.refreshData(subValue, opcoValue, ds);
                    // closing the loader in refresh data call.
                    DetailsComponent.decrementRunningRequests();

                }, 1000);
            }
        );
    }

    postRequestAL(URL: string, payload: string, subValue: string, opcoValue: string, ds: DialogService) {
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/json');

        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.post(URL, payload, options).subscribe(
            response => {
                this.translateKey = 'SHAREDCONSTANTS';
                this.translateValue = 'RO_RESET_SUCCESS';
                this.updateStatus = true;
            },
            error => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (error.json().internalCode && this.translate.checkAPIErrorExistsByCode(error.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(error.json().internalCode, 'API_ERROR')
                    });
                }
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                    });
                }
            },
            () => {
                setTimeout(() => {
                    this.refreshData(subValue, opcoValue, ds);
                    // closing the loader in refresh data call.
                    DetailsComponent.decrementRunningRequests();

                }, 1000);
            }
        );
    }

    postRequestVO(URL: string, payload: string, subValue: string, opcoValue: string, ds: DialogService, translateStr: string) {
        const headers = new Headers();
        headers.append('vf-target-environment', 'IDAAS_DEV');
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
          
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.post(URL, payload, options).subscribe(
            response => {
                this.translateKey = 'SHAREDCONSTANTS';
                this.translateValue = translateStr;
                this.updateStatus = true;
            },
            error => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (error.json().internalCode && this.translate.checkAPIErrorExistsByCode(error.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(error.json().internalCode, 'API_ERROR')
                    });
                }
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                    });
                }
            },
            () => {
                //this.refreshData(subValue, opcoValue, ds);
                setTimeout(() => {
                    this.refreshData(subValue, opcoValue, ds);
                    // closing the loader in refresh data call.
                    DetailsComponent.decrementRunningRequests();

                }, 1000);
            }
        );
    }

    postRequestRO(URL: string, payload: string, subValue: string, opcoValue: string, ds: DialogService) {
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/json');
        headers.append('external-user', this.agentEmail);

        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.post(URL, payload, options).subscribe(
            response => {
                //DetailsComponent.decrementRunningRequests();
                // this.loaderService.display(false);
                // ds.addDialog(NotificationDialogComponent,
                //     {
                //         success: true,
                //         message: new TranslatePipe(this.translate).transform('RO_RESET_SUCCESS','SHAREDCONSTANTS')
                //     });
                this.translateKey = 'SHAREDCONSTANTS';
                this.translateValue = 'RO_RESET_SUCCESS';
                this.updateStatus = true;
            },
            error => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (error.json().internalCode && this.translate.checkAPIErrorExistsByCode(error.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(error.json().internalCode, 'API_ERROR')
                    });
                }
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                    });
                }
                // if (error.status === 400) {
                //     if(error.json().code == "EMAIL_NOTPRESENT_EXCEPTION"){
                //         ds.addDialog(NotificationDialogComponent, {
                //             success: false,
                //             message: new TranslatePipe(this.translate).transform('EMAIL_NOTPRESENT_EXCEPTION','SHAREDCONSTANTS')
                //         });
                //     } else if(error.json().code == "EMAIL_NOTVERIFIED_EXCEPTION"){
                //         ds.addDialog(NotificationDialogComponent, {
                //             success: false,
                //             message: new TranslatePipe(this.translate).transform('EMAIL_NOTVERIFIED_EXCEPTION','SHAREDCONSTANTS')
                //         });
                //     }else if(error.json().code == "IDP_ERROR"){
                //         ds.addDialog(NotificationDialogComponent, {
                //             success: false,
                //             message: error.json().message
                //         });
                //     }
                // } 
                // else {
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // }
            },
            () => {
                //this.refreshData(subValue, opcoValue, ds);

                setTimeout(() => {
                    this.refreshData(subValue, opcoValue, ds);
                    // closing the loader in refresh data call.
                    DetailsComponent.decrementRunningRequests();

                }, 1000);
            }
        );
    }

    postRequest(URL: string, payload: string, subValue: string, opcoValue: string, ds: DialogService) {
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.post(URL, payload, options).subscribe(
            response => {
                //DetailsComponent.decrementRunningRequests();
                // this.loaderService.display(false);
                // ds.addDialog(NotificationDialogComponent,
                //     {
                //         success: true,
                //         message: new TranslatePipe(this.translate).transform('SUCCESS','GENERIC_MESSAGE')
                //     });
                this.translateKey = 'GENERIC_MESSAGE';
                this.translateValue = 'SUCCESS';
                this.updateStatus = true;
            },
            error => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (error.json().internalCode && this.translate.checkAPIErrorExistsByCode(error.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(error.json().internalCode, 'API_ERROR')
                    });
                }
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                    });
                }
                // if (error.status === 400) {
                //     if(error.json().code == "EMAIL_NOTPRESENT_EXCEPTION"){
                //         ds.addDialog(NotificationDialogComponent, {
                //             success: false,
                //             message: new TranslatePipe(this.translate).transform('EMAIL_NOTPRESENT_EXCEPTION','SHAREDCONSTANTS')
                //         });
                //     } else if(error.json().code == "EMAIL_NOTVERIFIED_EXCEPTION"){
                //         ds.addDialog(NotificationDialogComponent, {
                //             success: false,
                //             message: new TranslatePipe(this.translate).transform('EMAIL_NOTVERIFIED_EXCEPTION','SHAREDCONSTANTS')
                //         });
                //     }else if(error.json().code == "IDP_ERROR"){
                //         ds.addDialog(NotificationDialogComponent, {
                //             success: false,
                //             message: error.json().message
                //         });
                //     }
                // } 
                // else {
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // }
            },
            () => {
                //this.refreshData(subValue, opcoValue, ds);

                setTimeout(() => {
                    this.refreshData(subValue, opcoValue, ds);
                    // Closing the loader in refreshdata call
                    DetailsComponent.decrementRunningRequests();

                }, 1000);
            }
        );
    }

    customerLogoutRequest(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Operations_Logout);
        const payload = '{ \"logout_details\": { \"sub\":\"' + subValue + '\" }, \"device_details\": '
            + '{ \"user_agent\": \"CHROME8000\", \"device_id\": \"DE54DG32FD\", \"ip_address\": \"12.23.34.4\" } }';
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/json');

        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.post(URL, payload, options).subscribe(
            response => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                ds.addDialog(NotificationDialogComponent,
                    {
                        success: true,
                        message: new TranslatePipe(this.translate).transform('SUCCESS', 'GENERIC_MESSAGE')
                    });
            },
            error => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (error.json().internalCode && this.translate.checkAPIErrorExistsByCode(error.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(error.json().internalCode, 'API_ERROR')
                    });
                }
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                    });
                }
                // ds.addDialog(NotificationDialogComponent,
                //     {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
            }
        );
    }

    updateMail(newMail: string, subValue: string, opcoValue: string, ds: DialogService) {

        this.loaderService.display(true);

        const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update).replace('{sub}', subValue);
        const payload = '{\"user_details\":{\"email\": \"' + newMail + '\", \"email_verified\": false} }';
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/merge-patch+json');
        headers.append('If-None-Match', this.etagValue);
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.patch(URL, payload, options).subscribe(
            response => {
                //DetailsComponent.decrementRunningRequests();
                // this.loaderService.display(false);

                // ds.addDialog(NotificationDialogComponent, {
                //     success: true,
                //     message: new TranslatePipe(this.translate).transform('EMAIL_UPDATE_SUCESS','SHAREDCONSTANTS')
                // });
                this.translateKey = 'SHAREDCONSTANTS';
                this.translateValue = 'EMAIL_UPDATE_SUCESS';
                this.updateStatus = true;
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode, 'API_ERROR')
                    });
                }
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                    });
                }
                // if(err.json().code == "EMAIL_EXISTS_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('EMAIL_EXISTS_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "MSISDN_ALREADY_PRESENT_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('MSISDN_ALREADY_PRESENT_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "IDP_ERROR"){
                //         ds.addDialog(NotificationDialogComponent, {
                //             success: false,
                //             message: err.json().message
                //         });
                // }
                // else if (err.status !== 409) {
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // } else {
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('UPDATE_ERROR_409','SHAREDCONSTANTS')
                //     });
                // }
            },
            () => {
                setTimeout(() => {
                    this.refreshData(subValue, opcoValue, ds);

                    DetailsComponent.decrementRunningRequests();

                }, 1000);
            }
        );
    }

    updateMSISDN(newMSISDN: string, subValue: string, opcoValue: string, ds: DialogService, updateMSISDNStatus) {
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update).replace('{sub}', subValue);
        const payload = '{\"user_details\":{\"phone_number\": \"' + newMSISDN + '\", \"phone_number_verified\": false} }';
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/merge-patch+json');
        headers.append('If-None-Match', this.etagValue);
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.patch(URL, payload, options).subscribe(
            response => {
                //DetailsComponent.decrementRunningRequests();
                // this.loaderService.display(false);
                updateMSISDNStatus(false, false)
                // ds.addDialog(NotificationDialogComponent, {
                //     success: true,
                //     message: new TranslatePipe(this.translate).transform('MSISDN_UPDATE_SUCESS','SHAREDCONSTANTS')
                // });
                this.translateKey = 'SHAREDCONSTANTS';
                this.translateValue = 'MSISDN_UPDATE_SUCESS';
                this.updateStatus = true;
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)) {
                    updateMSISDNStatus(true, false)
                    // ds.addDialog(NotificationDialogComponent, {
                    //     success: false,
                    //     message: new TranslatePipe(this.translate).transform(err.json().internalCode,'API_ERROR')                   
                    // });
                }
                else {
                    updateMSISDNStatus(true, true)
                    ds.addDialog(NotificationDialogComponent, {

                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                    });
                }

                // if(err.json().code == "USER_IDENTIFICATION_PENDING"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('USER_IDENTIFICATION_PENDING','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "INVALID_MSISDN_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_MSISDN_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "IDP_ERROR"){
                //         ds.addDialog(NotificationDialogComponent, {
                //             success: false,
                //             message: err.json().message
                //         });
                // }
                // else if (err.status !== 409) {
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // } else {
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('UPDATE_ERROR_409','SHAREDCONSTANTS')
                //     });
                // }
            },
            () => {
                setTimeout(() => {
                    this.refreshData(subValue, opcoValue, ds);

                    DetailsComponent.decrementRunningRequests();

                }, 1000);
            }
        );
    }

    showMessage(ds) {

        ds.addDialog(NotificationDialogComponent, {
            success: true,
            message: new TranslatePipe(this.translate).transform(this.translateValue, this.translateKey)
        });
    }
    saveUpdatedUser(person: PersonDetailsUpdate, subValue: string, opcoValue: string, ds: DialogService) {
        console.log("in save update user");
        let URL;
        let payload;
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        if (opcoValue === 'ro') {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Ro).replace('{sub}', subValue);
            if (this.person == undefined) {
                payload = "{\"status\":\"DELETED\"}";
            }
            payload = person.getChangedDataRo(this.person);
        }
        else if (opcoValue === 'al') {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Al).replace('{sub}', subValue);
            if (this.person == undefined) {
                payload = "{\"status\":\"DELETED\"}";
            }
            payload = person.getChangedDataAl(this.person);
        }
        else if (opcoValue === 'cz') {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Cz).replace('{sub}', subValue);
            if (this.person == undefined) {
                payload = "{\"status\":\"DELETED\"}";
            }
            payload = person.getChangedDataCz(this.person);
        }
        else if (opcoValue === 'it') {
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_It).replace('{sub}', subValue);
            if (this.person == undefined) {
                payload = "{\"status\":\"DELETED\"}";
            }
            payload = person.getChangedDataCz(this.person);
        }
        else if(opcoValue === 'vo'){
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Vo).replace('{sub}', subValue);
            if (this.person == undefined) {
                payload = "{\"status\":\"TERMINATED\"}";
            }
            payload = person.getChangedDataVo(this.person);
        } else {
            //DetailsComponent.incrementRunningRequests();
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update).replace('{sub}', subValue);
            payload = person.getChangedData(this.person);
        }

        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/merge-patch+json');
        headers.append('If-None-Match', this.etagValue);
        headers.append('external-user', this.agentEmail);
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        console.log("Save date: " + payload);
        this.http.patch(URL, payload, options).subscribe(
            response => {
                //DetailsComponent.decrementRunningRequests();
                //this.loaderService.display(false);
                this.translateKey = 'SHAREDCONSTANTS';
                this.translateValue = 'CUSTOMER_UPDATE_SUCESS';
                this.updateStatus = true;

                setTimeout(() => {
                    // Refresh the page in case user is deleted/terminated
                    console.log('deleting user from customer service in patch call');
                    this.refreshData(subValue, opcoValue, ds);
                    DetailsComponent.decrementRunningRequests();

                }, 1000);

                // ds.addDialog(NotificationDialogComponent, {
                //     success: true,
                //     message: new TranslatePipe(this.translate).transform('CUSTOMER_UPDATE_SUCESS','SHAREDCONSTANTS')
                // });
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);

                if (err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode, 'API_ERROR')
                    });
                }
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
                    });
                }


                // if(err.json().code == "INVALID_FIRSTNAME_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_FIRSTNAME_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "INVALID_LASTTNAME_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_LASTTNAME_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "INVALID_COUNTRY_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_COUNTRY_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "INVALID_STREETADDRESS_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_STREETADDRESS_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "INVALID_REGION_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_REGION_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "INVALID_POSTALCODE_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_POSTALCODE_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "INVALID_LOCALITY_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_LOCALITY_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "INVALID_BIRTHDATE_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_BIRTHDATE_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "INVALID_BIRTHPLACE_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('INVALID_BIRTHPLACE_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "FUTURE_BIRTHDATE_EXCEPTION"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('FUTURE_BIRTHDATE_EXCEPTION','SHAREDCONSTANTS')
                //     });
                // }
                // else if(err.json().code == "IDP_ERROR"){
                //         ds.addDialog(NotificationDialogComponent, {
                //             success: false,
                //             message: err.json().message
                //         });
                // }
                // else if (err.status !== 409) {
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // } else {
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('UPDATE_ERROR_409','SHAREDCONSTANTS')
                //     });
                // }
            },
            () => {
                

            }
        );
    }

    refreshData(subValue: string, opcoValue: string, ds: DialogService) {

        this.reloadGetUserByRequest(subValue, opcoValue, ds);

    }

    getPerson(): PersonDetails {
        return this.person;
    }

    getCurrentEtag(): string {
        return this.etagValue;
    }

    getEnabledMobileConnectMarket(): boolean {
        return this.enabledMobileConnectMarket;
    }

    getEnabledAuthHistory(): boolean {
        return this.enabledHistoryMarket;
    }

    getEnabledMcLastSuccessfullLogin(): boolean {
        return this.enabledMcLastSuccessfullLogin;
    }

    getEnabledLogoutServices(): boolean {
        return this.enabledLogoutCustomerService;
    }

    getEnabledUpdateEmailButton(): boolean {
        return this.nvEmailUpdateBtnFlag;
    }

    setEtag(etag: string) {
        this.etagValue = this.getFormattedEtag(etag);
    }

    private getFormattedEtag(etag: string) {
        if (etag != null) {
            // if quotes are present delete.
            let etagTMP = etag.replace(new RegExp('\"', 'gi'), '');
            // if ends with -gzip delete
            const zipEnding = '-gzip';
            if (etagTMP.endsWith(zipEnding)) {
                etagTMP = etagTMP.substring(0, etagTMP.length - zipEnding.length);
            }
            return etagTMP;
        } else {
            return '';
        }
    }

    saveKYCChange(subValue: string,
        opcoValue: string,
        kycUpdateData: KycUpdateData,
        ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        //const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_KYC).replace('{sub}', subValue);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update).replace('{sub}', subValue);
        const payload = kycUpdateData.getChangedData(this.kycData);
        const header = new Headers();
        header.append('x-int-opco-id', opcoValue);
        header.append('Content-Type', 'application/merge-patch+json');
        header.append('If-None-Match', this.getCurrentEtag());
        const options = new RequestOptions({ headers: header, withCredentials: true });
        console.log("KYC SAVE URL: " + URL);
        console.log("KYC Data: " + payload);
        if (!this.kycData) {
            this.http.patch(URL, payload, options).subscribe(
                response => {
                    DetailsComponent.decrementRunningRequests();
                    this.loaderService.display(false);
                    console.log("KYC SAVE Success: " + response);
                },
                err => {
                    this.saveKYCChangeErrRespone(err, ds);
                },
                () => {

                    setTimeout(() => {
                        this.refreshData(subValue, opcoValue, ds);

                        DetailsComponent.decrementRunningRequests();

                    }, 1000);
                    //this.refreshData(subValue, opcoValue, ds);
                }
                //() => this.getCustomerKYCData(subValue, opcoValue, customerService)
            );
        } else {
            console.log("KYC Else PART" + payload);
            this.http.patch(URL, payload, options).subscribe(
                response => {

                    // this.loaderService.display(false);
                    // console.log("KYC SAVE Success: " + response);

                    // ds.addDialog(NotificationDialogComponent, {
                    //     success: true,
                    //     message: new TranslatePipe(this.translate).transform('KYC_UPDATE_SUCCESS','KYCUPDATEVIEWMESSAGES')
                    // });
                    this.translateKey = 'KYCUPDATEVIEWMESSAGES';
                    this.translateValue = 'KYC_UPDATE_SUCCESS';
                    this.updateStatus = true;
                },
                err => {
                    console.log("KYC SAVE Else Error: " + err);
                    this.saveKYCChangeErrRespone(err, ds);
                },
                () => {
                    console.log("Calling KYC Get call");

                    setTimeout(() => {
                        this.refreshData(subValue, opcoValue, ds);

                        DetailsComponent.decrementRunningRequests();

                    }, 1000);
                    //this.refreshData(subValue, opcoValue, ds);
                    //this.getCustomerKYCData(subValue, opcoValue, customerService);
                    //customerService.getUserByRequest(subValue, opcoValue, ds);
                }
            );
        }
    }

    RevokeKYCStatus(subValue: string, opcoValue: string, kycUpdateData: KycUpdateData, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        //const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_KYC).replace('{sub}', subValue);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update).replace('{sub}', subValue);
        const payload = kycUpdateData.getChangedData(this.kycData);
        const header = new Headers();
        header.append('x-int-opco-id', opcoValue);
        header.append('Content-Type', 'application/merge-patch+json');
        header.append('If-None-Match', this.getCurrentEtag());
        const options = new RequestOptions({ headers: header, withCredentials: true });
        this.http.patch(URL, payload, options).subscribe(
            response => {

                //  this.loaderService.display(false);
                // console.log("KYC SAVE Success: " + response);

                // ds.addDialog(NotificationDialogComponent, {
                //     success: true,
                //     message: new TranslatePipe(this.translate).transform('KYC_REVOKE_STATUS_SUCCESS_MESSAGE','DETAILSVIEWLABELS')
                // });
                this.translateValue = 'KYC_REVOKE_STATUS_SUCCESS_MESSAGE';
                this.translateKey = 'DETAILSVIEWLABELS';
                this.updateStatus = true;
            },
            err => {
                // console.log("KYC SAVE Else Error: " + err);
                this.saveKYCChangeErrRespone(err, ds);
            },
            () => {
                //  console.log("Calling KYC Get call");

                setTimeout(() => {
                    this.refreshData(subValue, opcoValue, ds);

                    DetailsComponent.decrementRunningRequests();

                }, 1000);

            }
        );
    }
    saveKYCChangeErrRespone(err, ds) {
        DetailsComponent.decrementRunningRequests();
        this.loaderService.display(false);

        if (err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)) {
            ds.addDialog(NotificationDialogComponent, {
                success: false,
                message: new TranslatePipe(this.translate).transform(err.json().internalCode, 'API_ERROR')
            });
        }
        else {
            ds.addDialog(NotificationDialogComponent, {
                success: false,
                message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE', 'SHAREDCONSTANTS')
            });
        }
        // if(err.json().code == "FUTURE_ISSUEDATE_EXCEPTION"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('FUTURE_ISSUEDATE_EXCEPTION','SHAREDCONSTANTS')
        //     });
        // }
        // else if(err.json().code == "PAST_EXPDATE_EXCEPTION"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('PAST_EXPDATE_EXCEPTION','SHAREDCONSTANTS')
        //     });
        // }
        // else if(err.json().code == "INVALID_PERSONALID_EXCEPTION"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('INVALID_PERSONALID_EXCEPTION','SHAREDCONSTANTS')
        //     });
        // }
        // else if(err.json().code == "INVALID_IDTYPE_EXCEPTION"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('INVALID_IDTYPE_EXCEPTION','SHAREDCONSTANTS')
        //     });
        // }
        // else if(err.json().code == "INVALID_FISCALCODE_EXCEPTION"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('INVALID_FISCALCODE_EXCEPTION','SHAREDCONSTANTS')
        //     });
        // }
        // else if(err.json().code == "INVALID_NATIONALITY_EXCEPTION"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('INVALID_NATIONALITY_EXCEPTION','SHAREDCONSTANTS')
        //     });
        // }
        // else if(err.json().code == "INVALID_EXPDATE_EXCEPTION"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('INVALID_EXPDATE_EXCEPTION','SHAREDCONSTANTS')
        //     });
        // }
        // else if(err.json().code == "INVALID_ISSUEDATE_EXCEPTION"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('INVALID_ISSUEDATE_EXCEPTION','SHAREDCONSTANTS')
        //     });
        // }
        // else if(err.json().code == "ISSUEDATE_BEFORE_BIRTHDATE_EXCEPTION"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('ISSUEDATE_BEFORE_BIRTHDATE_EXCEPTION','SHAREDCONSTANTS')
        //     });
        // }
        // else if(err.json().code == "IDP_ERROR"){
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: err.json().message
        //     });
        // }
        // else if (err.status !== 409) {
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
        //     });
        // } else {
        //     ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: new TranslatePipe(this.translate).transform('UPDATE_ERROR_409','SHAREDCONSTANTS')
        //     });
        // }
    }

    getKycData(): KycDetails {
        return this.kycData;
    }

    getUpdatedRoData(person) {
        localStorage.removeItem('createdDate');
        localStorage.removeItem('ModifieddDate');
        localStorage.removeItem("zoneModifiedDate");
        localStorage.removeItem("zoneCreatedDate");
        localStorage.setItem('createdDate', person.created_date);
        localStorage.setItem('ModifieddDate', person.modified_date);
        const zone = this.timezoneService.getZone();
        if (zone && zone !== 'null') {
            console.log('Timezone Service Zone=', this.timezoneService.getZone());
            this.timezoneService.setCreated_date(this.timezoneService.getZone(), person.created_date);
            this.timezoneService.setModified_date(this.timezoneService.getZone(), person.modified_date);
        }
        else{
            console.log('No timezone selected.');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/customer.service.ts